const constants = {
    ACTIONS : {
    GET_DOCTOR_ASSINGED:'GET_DOCTOR_ASSINGED',
    GET_DOCTOR_ASSINGED_FAILED:'GET_DOCTOR_ASSINGED_FA'
    }
}
export default constants;